import React, { useState, useEffect } from 'react';
import { List, Card, Typography, Spin, Alert } from 'antd';
import { getEvents } from '../services/eventsService';
import dayjs from 'dayjs';

const { Text, Title } = Typography;

function EventsWidget() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const data = await getEvents();
        // Filter and sort upcoming events
        const upcomingEvents = data
          .filter(event => dayjs(event.start_date).isAfter(dayjs()))
          .sort((a, b) => dayjs(a.start_date).diff(dayjs(b.start_date)))
          .slice(0, 7); // Get next 7 events
        setEvents(upcomingEvents);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = dateString => {
    const date = dayjs(dateString);
    return date.format('MMM D [at] h:mm A');
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '12px' }}>
        <Spin size="small" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '12px' }}>
        <Alert message={error} type="error" />
      </div>
    );
  }

  return (
    <Card
      title={
        <Title level={4} style={{ margin: 0 }}>
          Upcoming Events
        </Title>
      }
      style={{ width: '100%', maxWidth: 400 }}
    >
      <List
        dataSource={events}
        renderItem={event => (
          <List.Item
            style={{ cursor: 'pointer' }}
            onClick={() => window.open(event.ticket_url, '_blank')}
          >
            <List.Item.Meta title={event.name} description={formatDate(event.start_date)} />
          </List.Item>
        )}
        locale={{ emptyText: 'No upcoming events' }}
      />
    </Card>
  );
}

export default EventsWidget;
